import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { ClassType } from 'src/modules/utils/shared/class-type';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { EntityDefinition } from '../../models/entity-definition.model';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { FrontendForm } from '../../netgen/FrontendForm';
import { ButtonDefinition } from '../../models/button-definition.model';
import { GuiUtils } from 'src/modules/utils/misc/gui-utils';
import { Objects } from 'src/modules/utils/shared/objects';

@Component({
    selector: 'app-admin-base-edit',
    templateUrl: './admin-base-edit.component.html',
    styleUrl: './admin-base-edit.component.scss',
    standalone: false
})
export class AdminBaseEditComponent<T> extends ComponentView {

    neededParams: ObjectOfSimpleDataTypes = { id: "number" };
    id: number;

    multiInsert = false;
    definition: EntityDefinition<T>;
    item: T;
    form: FrontendForm;
    
    async initParams(): Promise<boolean> {
        this.item ??= this.isInsert() ? Objects.customInitialize(new this.definition.type as object) as T : await this.app.loadDataHandler(async () => this.getData(), this);
        await this.initAdditionalData();
        
        this.form = this.getForm();
        this.form.validateOnChange = true;
        await this.fillForm();
        this.form.validate();

        this.app.updateNavigation(null, [
            { label: "Administration", routerLink: ["/base2", "admin"] },
            this.getBreadcrumbItemParent(),
            this.getBreadcrumbItem()
        ]);

        GuiUtils.angularTimer(() => this.form.fields[0].focus());

        return true;
    }

    async getData(): Promise<T> {
        return await RestEndpoint.main().findById(this.id).run(this.definition.apiEndpoint).get(this.definition.type as ClassType<object>) as T;
    }

    async upsert(item: T): Promise<boolean> {
        return (await this.app.saveDataHandler(async () => RestEndpoint.main().upsert(item).run(this.definition.apiEndpoint).getText(), this, true, !this.multiInsert))[0];
    }

    async initAdditionalData(): Promise<void> {
    }

    async fillForm(): Promise<void> {
        this.form.fill(this.item);
        await Promise.resolve(null);
    }

    async fromForm(): Promise<void> {
        this.form.get(this.item);
        await Promise.resolve(null);
    }

    getDialogButtons(): ButtonDefinition[] {
        return [
            new ButtonDefinition("save", "Speichern", true, "fas fa-save", "", "success"),
            new ButtonDefinition("cancel", "Abbrechen", true, "fas fa-times", "", "secondary")
        ];
    }

    async buttonClickedFromExtern(id: string): Promise<void> {
        if (id == "save") {
            await this.save();
        }
        else if (id == "cancel") {
            await this.close();
        }
    }

    getForm(): FrontendForm {
        return new FrontendForm([]);
    }

    getBreadcrumbItem(): MenuItem {
        return { label: this.definition.name, routerLink: this.definition.getAdminEditUrl() + "/" + this.id };
    }
    
    getBreadcrumbItemParent(): MenuItem {
        return { label: this.definition.namePlural, routerLink: this.definition.adminListUrl };
    }

    isInsert(): boolean {
        return this.id == 0;
    }

    validateForm(): boolean {
        return this.app.validateForm(this.form);
    }

    async save(): Promise<void> {
        if (!this.validateForm()) {
            return;
        }

        await this.fromForm();
        
        let ok = await this.upsert(this.item);
        if (this.multiInsert && ok) {
            this.item = null;
            await this.initParams();
        }
    }

    async saveNew(): Promise<void> {
        if (!this.validateForm()) {
            return;
        }

        await this.fromForm();
        (this.item as any).id = 0;
        let ok = await this.upsert(this.item);
        if (this.multiInsert && ok) {
            this.item = null;
            await this.initParams();
        }
    }
}
